import { Tabs } from "@mantine/core";
import { paywall } from "./Authentication";
import UserMenu from "./UserMenu";
import classes from "./NavMenu.module.css";
import { useNavigate } from "react-router-dom";
import { User } from "./models";
import { useViewportSize } from "@mantine/hooks";
import cn from "classnames";

interface Props {
    user?: User;
    selected: "play" | "positions" | "statistics";
    onClickPlay?: () => void;
}

const Header: React.FC<Props> = ({ user, selected, onClickPlay }) => {
    const { width } = useViewportSize();
    const navigate = useNavigate();

    const isLoggedIn = !!user;
    const isMobile = width < 1024;
    return (
        // <Affix position={isMobile ? { top: rem(10), left: rem(5) } : { top: rem(10), right: rem(30) }}>
        <div
            className={cn(
                "flex items-center w-[100vw] bg-[#1a1a1a] z-50 pt-2 [@media(max-width:1023px)]:pl-2 [@media(max-width:1023px)]:left-0 [@media(min-width:1023px)]:mb-6",
                {
                    "max-lg:bg-[#25262B]": selected === "play" || selected === "positions",
                    "justify-between": isLoggedIn,
                    "justify-end": !isLoggedIn,
                },
            )}
        >
            {/* <Image src="/logo.png" alt="OpeningTrainer logo" h={40} ml="4rem" mt="0.5rem" /> */}
            {!isMobile && isLoggedIn && (
                <Tabs
                    mt="0.8rem"
                    ml="2rem"
                    defaultValue={selected}
                    variant="default"
                    value={selected}
                    classNames={{
                        root: classes.tabs,
                        list: classes.tabsList,
                        tab: classes.tab,
                    }}
                >
                    <Tabs.List className="mb-4 flex items-center">
                        <Tabs.Tab
                            value="play"
                            w={120}
                            onClick={async () => {
                                navigate("/");
                                if (onClickPlay) {
                                    onClickPlay();
                                }
                            }}
                        >
                            Play
                        </Tabs.Tab>
                        <Tabs.Tab
                            value="statistics"
                            w={120}
                            onClick={async () => {
                                const didRedirect = await paywall(user);
                                if (!didRedirect) {
                                    navigate(`/stats`);
                                }
                            }}
                        >
                            Statistics
                        </Tabs.Tab>
                        <Tabs.Tab
                            value="positions"
                            w={120}
                            onClick={async () => {
                                const didRedirect = await paywall(user);
                                if (!didRedirect) {
                                    navigate("/positions");
                                }
                            }}
                        >
                            Positions
                        </Tabs.Tab>

                        {/* <Select
                                        className="ml-auto"
                                        label=""
                                        placeholder="Pick value"
                                        data={["All time", "Today", "Last 3 days", "Last 7 days", "Last 30 days"]}
                                        defaultValue={"All time"}
                                        allowDeselect={false}
                                        onChange={(option) => {
                                            handleChangeDateRange(option as string);
                                        }}
                                    /> */}
                        {/* {isLoggedIn ? (
                                        <UserMenu user={user} />
                                    ) : (
                                        <a
                                            className="flex justify-center py-4 cursor-pointer col-start-2"
                                            href="/login"
                                        >
                                            Sign in
                                        </a>
                                    )} */}
                        {/* {!isLoggedIn && import.meta.env.DEV && (
                            <Button
                                onClick={async () => {
                                    await login("lol", "123123");
                                    location.reload();
                                }}
                            >
                                Sign in
                            </Button>
                        )} */}
                    </Tabs.List>
                </Tabs>
            )}
            {isLoggedIn ? (
                <UserMenu user={user!} />
            ) : (
                <a className="flex justify-center py-4 cursor-pointer col-start-2 mr-8" href="/login">
                    Sign in
                </a>
            )}
            {/* {!isLoggedIn && import.meta.env.DEV && (
                    <Button
                        onClick={async () => {
                            await login("lol", "123123");
                            location.reload();
                        }}
                    >
                        Sign in
                    </Button>
                )} */}
        </div>
        // </Affix>
    );
};

export default Header;

{
    /* <UserMenu user={user} /> */
}
